import { Alert, Button, Card, Form, Input, InputNumber } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import * as React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import adSizeApi from './AdSizeApi'

const FormItem = Form.Item

interface Props { }

const AdSizeCreate: React.FC<Props> = () => {

    const [form] = useForm()
    const [error, setError] = useState()
    const navigateTo = useNavigate()

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await adSizeApi.create(values)
            navigateTo('/ad-size')
        } catch (e) {
            setError(e.error)
        }
    }

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
    >
        {error ? <Alert message={error} type="error" /> : null}
        <Card size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
            >
                <Input />
            </FormItem>
            <FormItem
                required
                name="width"
                label="Width"
            >
                <InputNumber min={1} max={10000} />
            </FormItem>
            <FormItem
                required
                name="height"
                label="Height"
            >
                <InputNumber min={1} max={10000} />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Create</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/ad-size')}>Cancel</Button>
        </div>
    </Form>
}

export default AdSizeCreate


// WEBPACK FOOTER //
// ./src/component/app/adSize/AdSizeCreate.tsx